import gsap from "gsap";
import Chart from "chart.js";

export default {
	name: "AppChart",
	props: {
		chartsdata: {
			type: Array,
		},
	},
	data() {
		return {
			canvas: null,
			canvasContainer: [],
			charts: [],
			currentChartIndex: 0,
			direction: 0,
			mqlA: true,
			canvasRendered: new Set(),
			isInitialRender: false
		};
	},
	computed: {
		chartsData() {
			return this.chartsdata;
		},
		chartsPercent() {
			const chartsPercentage = [];
			this.chartsData.forEach((chart) => {
				let chartPercantage = [];
				chart.forEach((el) => {
					chartPercantage.push(el.chart_percent);
				});
				chartsPercentage.push(chartPercantage);
			});

			return chartsPercentage;
		},
		chartsColors() {
			const chartsColors = [];

			this.chartsData.forEach((chart) => {
				let chartColors = [];
				chart.forEach((el) => {
					chartColors.push(el.chart_color);
				});

				chartColors.push("transparent");
				chartsColors.push(chartColors);
			});

			return chartsColors;
		},
		chartsLegends() {
			const chartsLegends = [];

			this.chartsData.forEach((chart) => {
				let chartLegend = [];
				chart.forEach((el) => {
					chartLegend.push(el.chart_legend);
				});

				chartsLegends.push(chartLegend);
			});

			return chartsLegends;
		}
	},
	created() {
		window.addEventListener("resize", this.handleResize);
		window.addEventListener('scroll', this.handleScroll)
	},
	mounted() {
		Chart.defaults.global.defaultFontFamily = "neogroteskpro-regular";
		this.canvasContainer = document.querySelectorAll(".chart__element__wrapper__container");
		this.canvas = document.querySelectorAll('canvas')
		this.mqlA = window.matchMedia("(max-width: 420px)").matches;

		if (this.mqlA) {
			this.setUpCanvasSwipe();
		}
		this.observeChart();
		this.enterAnim()
	},
	beforeDestroy() {
		window.removeEventListener("resize", this.handleResize);
		window.removeEventListener('scroll', this.handleScroll)
	},
	methods: {
		observeChart() {

			let optionsFirstEnter = {
				rootMargin: "0px",
				threshold: 0.4
			}

			let observerFirstEnter = new IntersectionObserver((entries) => {
				entries.forEach((enter) => {
					if (enter.intersectionRatio >= 0.4 && enter.boundingClientRect.top > 0) {
						this.canvas.forEach((el, index) => {
							if (!this.canvasRendered.has(index)) {
								if (this.mqlA && index != this.currentChartIndex) {
									this.drawChart
								} else {
									setTimeout(() => {
										this.drawChart(el, index)
									}, 200 * index)
								}
							}
						})
						this.isInitialRender = true;
						observerFirstEnter.unobserve(this.$refs.canvasWrapper)
					}
				})
			}, optionsFirstEnter);

			observerFirstEnter.observe(this.$refs.canvasWrapper);

			let optionsEnter = {
				rootMargin: "0px",
				threshold: 0.4
			}

			let observerEnter = new IntersectionObserver((entries) => {
				entries.forEach((enter) => {
					if (enter.intersectionRatio >= 0.4 && enter.boundingClientRect.top > 0) {
						this.charts.forEach((el, index) => {
							el.stop();
							setTimeout(() => {
								el.update();
							}, 200 * index)
						})
					}
				})
			}, optionsEnter);

			observerEnter.observe(this.$refs.canvasWrapper);

			let optionsLeave = {
				rootMargin: "0px",
				threshold: 0
			}

			let observerLeave = new IntersectionObserver((entries) => {
				entries.forEach((enter) => {
					if (enter.intersectionRatio == 0 && enter.boundingClientRect.top > 0) {
						this.clearHover();
						this.charts.forEach(el => {
							el.stop();
							el.reset();
							el.render()
						})
					}
				})
			}, optionsLeave);

			observerLeave.observe(this.$refs.canvasWrapper);
		},
		clearHover() {
			const activeHover = document.querySelector('.chart__element__wrapper__container__legends__wrapper.var_active');
			const chartTooltip = document.querySelector('#chartjs-tooltip');
			this.charts.forEach(el => {
				el.update();
			})

			if (activeHover) {
				activeHover.classList.remove('var_active');
				activeHover.children[0].removeAttribute('style');
			}

			if (chartTooltip) {
				chartTooltip.style.opacity = 0;
				chartTooltip.style.visibility = 'hidden';
			}
		},
		drawChart(canvas, index) {
			let chart = new Chart(canvas, {
				type: "doughnut",
				data: {
					datasets: [
						{
							data: this.chartsPercent[index],
							backgroundColor: this.chartsColors[index],
							hoverBorderWidth: 10,
							hoverBorderColor: this.chartsColors[index],
							hoverBackgroundColor: this.chartsColors[index],
							borderColor: "transparent",
							borderWidth: 0,
						},
					],
					labels: this.chartsLegends[index]
				},
				options: {
					legend: {
						display: false
					},
					tooltips: {
						enabled: false,

						custom: function (tooltipModel) {
							// Tooltip Element
							var tooltipEl = document.getElementById('chartjs-tooltip');

							// Create element on first render
							if (!tooltipEl) {
								tooltipEl = document.createElement('div');
								tooltipEl.id = 'chartjs-tooltip';
								tooltipEl.innerHTML = '<table></table>';
								document.body.appendChild(tooltipEl);
							}

							// Hide if no tooltip
							if (tooltipModel.opacity === 0) {
								tooltipEl.style.opacity = 0;
								return;
							}

							// Set caret Position
							tooltipEl.classList.remove('above', 'below', 'no-transform');
							if (tooltipModel.yAlign) {
								tooltipEl.classList.add(tooltipModel.yAlign);
							} else {
								tooltipEl.classList.add('no-transform');
							}

							function getBody(bodyItem) {
								return bodyItem.lines;
							}

							// Set Text

							if (tooltipModel.body) {
								var titleLines = tooltipModel.title || [];
								var bodyLines = tooltipModel.body.map(getBody);
								var innerHtml = '<thead>';

								titleLines.forEach(function (title) {
									innerHtml += '<tr><th>' + title + '</th></tr>';
								});
								innerHtml += '</thead><tbody>';

								bodyLines.forEach(function (body) {
									const prepare = body[0].split(' ');
									let percentage = prepare[prepare.length - 1];
									innerHtml += '<tr><td>' + percentage + '%</td></tr>';
								});
								innerHtml += '</tbody>';

								var tableRoot = tooltipEl.querySelector('table');
								tableRoot.innerHTML = innerHtml;
							}

							// `this` will be the overall tooltip
							var position = this._chart.canvas.getBoundingClientRect();
							tooltipEl.style.opacity = 1;
							tooltipEl.style.position = 'absolute';
							tooltipEl.style.fontFamily = tooltipModel._bodyFontFamily;
							tooltipEl.style.fontSize = 15 + 'px';
							tooltipEl.style.fontStyle = tooltipModel._bodyFontStyle;
							tooltipEl.style.color = '#08473e';
							tooltipEl.style.pointerEvents = 'none';
							tooltipEl.style.visibility = 'visible';
							tooltipEl.style.transition = 'opacity 0.3s';
							tooltipEl.style.top = position.top + window.pageYOffset + (this._chart.canvas.offsetHeight / 2) - (tooltipEl.offsetHeight / 2) + 'px';
							tooltipEl.style.left = position.left + (this._chart.canvas.offsetWidth / 2) - (tooltipEl.offsetWidth / 2) + 'px';

						}
					},
					onHover: (e, item) => {
						if (item[0] == undefined) {
							const activeLegend = document.querySelector(".chart__element__wrapper__container__legends__wrapper.var_active");
							if (activeLegend) {
								activeLegend.classList.remove("var_active");
								activeLegend.children[0].style.color = "#08473e";
							}
						} else {
							const canvasIndex = e.target.parentElement.parentElement.getAttribute('data-chart');
							let chartContainer = document.querySelector(`div[data-chart="${canvasIndex}"]`);
							let chartLegend = chartContainer.querySelector(".chart__element__wrapper__container__legends");

							chartLegend.children.forEach((el, index) => {
								if (index == item[0]._index) {
									const color = 'rgb(8, 71, 62)';
									const backgroundColor = window.getComputedStyle(el.children[1]).backgroundColor;

									if (color == backgroundColor) {
										el.children[0].style.color = "#ffffff"
									}
									el.classList.add("var_active");
								} else {
									el.classList.remove("var_active");
									el.children[0].removeAttribute('style')
								}
							});
						}
					},
				},
			});


			this.charts.push(chart)
			this.canvasRendered.add(index)
		},
		enterAnim() {
			let tl = gsap.timeline({
				scrollTrigger: {
					trigger: '.chart__context__description',
					start: "top bottom-=10%",
					end: "bottom bottom-=10%",
					scrub: 0.8
				}
			});

			tl
				.fromTo(this.$refs.leftDes, { autoAlpha: 0, y: 150 }, { y: 0, autoAlpha: 1 })
				.fromTo(this.$refs.rightDes, { autoAlpha: 0, y: 150 }, { y: 0, autoAlpha: 1 }, '+=0.0')

		},
		handleResize() {
			this.mqlA = window.matchMedia("(max-width: 420px)").matches;

			if (this.mqlA) {
				this.setUpCanvasSwipe();
				this.currentChartIndex = 0;
			} else {
				this.checkChartDraw();
				this.resetChartSwipe();
			}
		},
		checkChartDraw() {
			if (!this.canvas) return
			if (this.isInitialRender) {
				const canvasRendered = [...this.canvasRendered];
				this.canvas.forEach((el, index) => {
					const dataIndex = el.parentElement.parentElement.getAttribute('data-chart') * 1;
					const isExist = canvasRendered.includes(dataIndex)
					if (!isExist) {
						this.canvasRendered.add(index)
						setTimeout(() => {
							this.drawChart(el, index)
						}, 200 * index)
					}
				})
			}
		},
		setUpCanvasSwipe() {
			this.canvasContainer.forEach((el, index) => {
				if (index == 0) return;

				gsap.set(el, { x: window.outerWidth });
			});
		},
		onSwipe(event) {
			if (!this.mqlA) return;

			if (event.type == "swipeleft") {
				this.direction = -1;
				if (this.currentChartIndex != this.canvasContainer.length - 1) {
					this.currentChartIndex += 1;
				}
			} else if (event.type == "swiperight") {
				this.direction = 1;
				if (this.currentChartIndex != 0) {
					this.currentChartIndex -= 1;
				}
			}
		},
		swipeAnimation(newVal, oldVal) {
			gsap
				.timeline({
					onStart: () => this.clearHover(),
					onComplete: () => {
						this.setOtherCharts()
						if (this.charts.length != this.chartsData.length && !this.canvasRendered.has(this.currentChartIndex)) {
							const canvasContainer = document.querySelector(`div[data-chart="${this.currentChartIndex}"]`);
							const currentCanvas = canvasContainer.querySelector('canvas');
							this.drawChart(currentCanvas, this.currentChartIndex)
						}
					}
				})
				.to(this.canvasContainer[oldVal], { duration: 0.5, x: this.direction * window.outerWidth })
				.to(this.canvasContainer[newVal], { duration: 0.5, x: 0 }, "-=0.5");
		},
		changeSlide(index) {
			if (index >= this.currentChartIndex) {
				this.direction = -1;
			} else {
				this.direction = 1;
			}
			this.currentChartIndex = index;
		},
		setOtherCharts() {
			this.canvasContainer.forEach((el, index) => {
				if (index == this.currentChartIndex) return;

				if (index < this.currentChartIndex) {
					gsap.set(el, { x: -window.outerWidth });
				} else {
					gsap.set(el, { x: window.outerWidth });
				}
			});
		},
		resetChartSwipe() {
			this.clearHover();
			this.canvasContainer.forEach((el) => {
				gsap.set(el, { clearProps: "transform,padding" });
			});

			gsap.set(this.$refs.canvasWrapper, { clearProps: "transform,padding" });
		},
		handleScroll() {
			if (this.charts.length == 0 && this.$refs.canvasWrapper.getBoundingClientRect().top < 0) {
				this.canvas.forEach((el, index) => {
					if (this.mqlA && index != this.currentChartIndex) {
						this.drawChart
					} else {
						setTimeout(() => {
							this.drawChart(el, index)
						}, 200 * index)
					}
				})
				this.isInitialRender = true;
			}
		}
	},
	watch: {
		currentChartIndex(newVal, oldVal) {
			this.swipeAnimation(newVal, oldVal);
		},
	},
};
